export const authenticateLegacy = async (
  client,
  documentId,
  appSessionId,
  sessionId
) => {
  //ask the server for an authentication token based on scribonline login
  var host =
    'https://lx8nyvnf97.execute-api.us-east-1.amazonaws.com/development';
  if (process.env.NODE_ENV === 'development') {
    host = 'https://lx8nyvnf97.execute-api.us-east-1.amazonaws.com/development';
  }
  return fetch(`${host}/legacy/authenticate`, {
    method: 'POST',
    credentials: 'same-origin',
    body: JSON.stringify({
      client,
      documentId,
      appSessionId,
      sessionId
    })
  })
    .then(response => {
      if (response.status !== 200) {
        return Promise.reject(`Returned code ${response.status}`);
      }
      return response.json();
    })
    .catch(error => {
      return Promise.reject(error);
    });
};
